module.exports = __webpack_public_path__ + "static/media/dinner.90226185.svg";